import type { Integer, String } from "./Brand"

/**
 * Globally Unique Identifier as 256-bit bigint.
 *
 * Branded type for type safety. Used for hash outputs (SHA-256).
 */
export type GUID = Integer<"GUID", "u256">

/**
 * GUID as hex string representation.
 *
 * String form of GUID for serialization/display.
 */
export type StringGUID = String<"GUID">

/**
 * Union of bigint and string GUID forms.
 */
export type AnyGUID = GUID | StringGUID
